export default "__VITE_ASSET__K0g$aGIR__"